import './text-slice.scss';
import PropTypes from "prop-types"
import React from "react"

const TextSlice = ( { slice } ) => {
    return <div dangerouslySetInnerHTML={{ __html: slice.primary.text.html }} />;
};

TextSlice.propTypes = {
    slice: PropTypes.object.isRequired,
}

export default TextSlice
